(() => {
  const main = document.getElementById('MainContent');
  if (!main || !document.body.classList.contains('cocon-product')) return;
  const mobile = matchMedia('(max-width:767px)');
  const layer = document.createElement('div');
  layer.className = 'cocon-mobile-gap-drawings';
  layer.setAttribute('aria-hidden', 'true');
  const selector = [
    '.story-section > .page-shell', '.feeder-section > .page-shell',
    '#release-3l .fountain-flow > .wrap', '#release-3l .fountain-settings > .wrap',
    '#release-3l .fountain-care > .wrap', '#release-3l section.wrap:not(.product-page)',
    '#release-3l .fountain-close.wrap-wide',
    '#release-inox .inox-section.inox-wrap:not(.inox-hero)',
    '#release-inox .bowl-compare-section.inox-wrap', '#release-inox .inox-final.inox-wrap',
    '.bottom-note', '.product-story.wrap', '.product-details.wrap',
    '.restored-start.wrap', '.faq-section.wrap', '.restored-closing.wrap', 'section.section.wrap'
  ].join(',');
  const originalBounds = [[17,46],[28,70],[109,147],[164,203],[160,179]];
  let frame;
  let lastPositions = null;
  function updateGaps() {
    if (!mobile.matches) {
      if (layer.isConnected) layer.remove();
      lastPositions = null;
      return;
    }
    // Measure all section bounds before changing the decorative layer.
    const positionsToPaint = [];
    const candidates = [...main.querySelectorAll(selector)];
    const cards = candidates.filter(card => !candidates.some(other => other !== card && other.contains(card)))
      .map(card => card.getBoundingClientRect()).filter(rect => rect.width > 0 && rect.height > 0);
    let added = 0;
    for (let i = 1; i < cards.length && added < 5; i++) {
      const previous = cards[i - 1], next = cards[i];
      const start = previous.bottom + scrollY, end = next.top + scrollY;
      if (end - start < 52 || end - start > 100) continue;
      const illustrated = originalBounds.some(([a,b]) => {
        const first = Math.floor((start - 150) / 255) - 1;
        for (let row = first; row < first + 4; row++) {
          if (Math.min(end,150 + row * 255 + b) - Math.max(start,150 + row * 255 + a) > 9) return true;
        }
        return false;
      });
      if (illustrated) continue;
      const positions = i % 2 ? [.30,.73] : [.25,.68];
      for (let j = 0; j < positions.length && added < 5; j++) {
        positionsToPaint.push({
          name: j === 0 ? 'cat' : i % 2 ? 'heart' : 'paw',
          left: (next.left + scrollX + next.width * positions[j]) + 'px',
          top: ((start + end) / 2 + (j ? 2 : -2)) + 'px'
        });
        added++;
      }
    }
    const positionKey = JSON.stringify(positionsToPaint);
    if (positionKey === lastPositions && layer.isConnected) return;
    const fragment = document.createDocumentFragment();
    for (const position of positionsToPaint) {
      const motif = document.createElement('span');
      motif.className = position.name;
      motif.style.left = position.left;
      motif.style.top = position.top;
      fragment.append(motif);
    }
    layer.replaceChildren(fragment);
    if (!layer.isConnected) document.body.append(layer);
    lastPositions = positionKey;
  }
  function scheduleGaps() { cancelAnimationFrame(frame); frame = requestAnimationFrame(updateGaps); }
  new ResizeObserver(scheduleGaps).observe(main);
  mobile.addEventListener('change', scheduleGaps);
  addEventListener('resize', scheduleGaps);
  addEventListener('load', scheduleGaps, {once:true});
  document.addEventListener('shopify:section:load', scheduleGaps);
  document.fonts.ready.then(scheduleGaps);
  scheduleGaps();
})();
